import { render, staticRenderFns } from "./VinculoFornecedor.vue?vue&type=template&id=ea09db3a&"
import script from "./VinculoFornecedor.vue?vue&type=script&lang=js&"
export * from "./VinculoFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports